import React, { FC } from 'react';

import { isNil } from 'lodash-es';
import { useIntl } from 'react-intl';

import { useLoyaltyActiveCard } from 'hooks/loyalty';

import { RewardTierBaseProps } from '../reward-tier/types';

import {
  Container,
  InformationContainer,
  RewardsWrapper,
  Subtitle,
  TierLabel,
  Title,
  TitleWrapper,
} from './reward-tier-no-input.styled';

export const RewardTierNoInput: FC<RewardTierBaseProps> = ({
  children,
  name = '',
  points,
  tierLabel,
  titleId,
}) => {
  const { formatMessage } = useIntl();
  const { loyaltyDetails } = useLoyaltyActiveCard();
  const hasEnoughPoints = Boolean(
    points && loyaltyDetails && !isNil(loyaltyDetails.points) && loyaltyDetails.points < points
  );

  return (
    <Container>
      <InformationContainer>
        <TitleWrapper>
          <Title id={titleId}>{name}</Title>
          {!hasEnoughPoints && <Subtitle>{formatMessage({ id: 'notEnoughPoints' })}</Subtitle>}
        </TitleWrapper>
        <RewardsWrapper>
          <TierLabel>{tierLabel} Points</TierLabel>
        </RewardsWrapper>
      </InformationContainer>
      {children}
    </Container>
  );
};
